import { useTranslation } from '@framework/i18n';
import { Empty, Space } from 'antd';
import React from 'react';
import type { SharedResourceFile } from '../sharedResourceTypes';
import { SharedResourceFileRow } from './SharedResourceFileRow';

export interface SharedResourceFileListProps {
  maskedId: string;
  files: SharedResourceFile[];
}

export function SharedResourceFileList(props: SharedResourceFileListProps) {
  const { maskedId, files } = props;
  const { t } = useTranslation();

  if (files.length === 0) {
    return (
      <Empty
        description={t(
          'shared-resource.no-files',
          'Nessun file disponibile per il download',
        )}
      />
    );
  }

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {files.map(file => (
        <SharedResourceFileRow
          key={file.fileId}
          maskedId={maskedId}
          file={file}
        />
      ))}
    </Space>
  );
}
